export default __webpack_public_path__ + "static/media/edit.ae49bce1.svg";